import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { Icon } from './../../../components/Layout'

import { useAuth } from './../../../context/Auth'

const DouInfo = React.memo(({ load, dataDou }) => {

    const { getMenu } = useAuth()
    const history = useHistory()
    const menuShow = getMenu()

    function onOpenPageDou() {
        history.push('/dou')
    }

    function LoadDou() {
        return (
            <div className='dou-skeleton-wrapper'>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <Skeleton width={16} height={16} circle />
                    <Skeleton width={80} height={14} />
                </div>
                <div><Skeleton width='90%' height={20} /></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <Skeleton width={16} height={16} />
                    <Skeleton width={60} height={14} />
                </div>
                <div><Skeleton count={3} height={14} style={{ marginBottom: 4 }} /></div>
                <div>
                    <Skeleton width='100%' height={36} style={{ borderRadius: 6 }} />
                </div>
            </div>
        )
    }

    function SemDou() {
        return (
            <div className='nofiles-dash-dou'>
                <img src='../assets/images/nofiles/nofile-dou.svg' alt="Empty" />
                <span>Nenhum DOU encontrado</span>
            </div>
        )
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className='dou-card'>
                    <div className='dou-header-title'>
                        <Icon name='ti-package' />
                        <span>Último DOU encontrado</span>
                    </div>

                    {
                        load ? <LoadDou /> :
                            dataDou.length === 0 ? <SemDou /> :
                                <>
                                    <div className='dou-content-wrapper'>
                                        <div className='client-info'>
                                            <Icon name='ti-user' />
                                            <span>{dataDou.cliente}</span>
                                        </div>

                                        <div className='doc-title'>
                                            {dataDou.titulo}
                                        </div>

                                        <div className='doc-date'>
                                            <Icon name='ti-calendar' />
                                            <span>{dataDou.data_consulta}</span>
                                        </div>

                                        <div className='doc-description'>
                                            {dataDou.descricao}
                                        </div>

                                        <div className='dou-actions'>
                                            <a href={dataDou.link} target='_blank' rel="noreferrer" className='btn-dou'>
                                                <Icon name='ti-link' />
                                                Acessar
                                            </a>
                                        </div>
                                    </div>

                                    {
                                        dataDou.length !== 0 && String(menuShow) !== '4' &&
                                        <div className='dou-footer-link' onClick={onOpenPageDou}>
                                            ver todos <Icon name='ti-angle-right' />
                                        </div>
                                    }
                                </>
                    }
                </div>
            </div>
        </div>
    )
})

export default DouInfo